<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.push({ name: 'settingsEntry' })">工作室设置</em>
          <label><i class="el-icon-arrow-right"></i> 修改基础信息</label>
        </div>
      </div>
      <div class="content-inner-wrap">
        <el-form
          :label-position="'right'"
          :rules="rules"
          ref="ruleForm"
          label-width="153px"
          :model="ruleForm"
        >
          <el-form-item label="工作室名称" prop="name">
            <el-input
              placeholder="请填写工作室名称"
              v-model="ruleForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作室ID">
            {{ ruleForm.studio_id }}
          </el-form-item>
          <el-form-item label="工作室logo" prop="fileList">
            <my-el-upload
              :action="upload_url"
              class="upload-demo"
              :file-list="ruleForm.fileList"
              :on-remove="onRemove"
              :on-change="onChangeLogo"
              name="image"
              accept="image/png,image/jpeg,image/bmp"
              list-type="picture"
            >
              <el-button size="small" class="uploadBtn">
                <i class="icon icon-upload"></i><span>上传文件</span></el-button
              >
              <div slot="tip" class="el-upload__tip">
                <p>请上传工作室的LOGO图片，建议尺寸为：200*200</p>
                <p>格式支持PNG、BMP、JPG，图片大小控制在10M以内</p>
              </div>
            </my-el-upload>
          </el-form-item>
          <el-form-item label="工作室简介" prop="description">
            <el-input
              type="textarea"
              rows="4"
              placeholder="请填写工作室简介"
              v-model="ruleForm.description"
            ></el-input>
            <template slot="error">
              <div class="el-form-item__error">
                简介信息请控制在 10 至 150 字之间
              </div>
            </template>
          </el-form-item>
          <el-form-item label="工作室公告" prop="notice">
            <el-input
              type="textarea"
              rows="4"
              placeholder="请填写工作室公告"
              v-model="ruleForm.notice"
            ></el-input>
            <template slot="error">
              <div class="el-form-item__error">
                公告信息请控制在 10 至 150 字之间
              </div>
            </template>
          </el-form-item>
          <el-form-item label="是否允许加入" prop="allow_join">
            <el-select v-model="ruleForm.allow_join" placeholder="请选择">
              <el-option label="允许申请" :value="true"> </el-option>
              <el-option label="不允许申请" :value="false"> </el-option>
            </el-select>
          </el-form-item>
          <div class="largeBtnGroup">
            <el-button
              class="largeCenterBtn"
              type="primary"
              @click="submitForm('ruleForm')"
              >提交申请</el-button
            >
            <el-button
              class="largeCenterBtn"
              type="info"
              @click="$router.push({ name: 'settingsEntry' })"
              >取消</el-button
            >
          </div>
          <p class="el-tips">修改的内容需要审核后才会生效</p>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import MyUpload from '../../../../components/MyUpload';
import { getStudioDetail, updateStudioProfile } from '@/api/studio';
import { UPLOAD_URL, checkLenStudioName, isValidFileSize } from '../../CONST';
export default {
  data() {
    return {
      upload_url: UPLOAD_URL,
      ruleForm: {
        studio_id: 0,
        allow_join: 0,
        name: '',
        notice: '',
        head: '',
        description: '',
        fileList: [],
      },
      rules: {
        name: [
          { required: true, message: '请输入工作室名称', trigger: 'blur' },
          { min: 6, max: 24, trigger: 'blur', validator: checkLenStudioName },
        ],
        notice: [
          {
            required: true,
            message: '请输入公告内容，最多150字',
            trigger: 'change',
          },
          { min: 10, max: 150, trigger: 'change' },
        ],
        description: [
          {
            required: true,
            message: '请输入工作室描述，最多150字',
            trigger: 'change',
          },
          { min: 10, max: 150, trigger: 'change' },
        ],
        fileList: [
          {
            type: 'array',
            required: true,
            message: '请上传工作室logo',
            trigger: 'change',
          },
        ],
      },
    };
  },
  async created() {
    let studioBaseInfo = sessionStorage.getItem('studioBaseInfo');
    if (studioBaseInfo) {
      studioBaseInfo = JSON.parse(studioBaseInfo);
    } else {
      let res = await getStudioDetail();
      studioBaseInfo = res.data;
      sessionStorage.setItem('studioBaseInfo', JSON.stringify(studioBaseInfo));
    }
    let { name, studio_id, head, description, notice, allow_join } =
      studioBaseInfo;
    this.ruleForm = {
      name,
      studio_id,
      head,
      description,
      notice,
      allow_join: !!allow_join,
      fileList: [{ name: '原logo', url: head }],
    };
  },
  components: {
    [MyUpload.name]: MyUpload,
  },
  methods: {
    onBeforeUpload(file) {
      return isValidFileSize(file.size, () =>
        this.$message.error('请限制文件大小在10M以内'),
      );
    },
    onChangeLogo(file, fileList) {
      console.log('onChangeLogo', file, fileList, this.ruleForm.fileList);
      if (file.status === 'success' && file.response.code === 200) {
        let { image } = file.response.data;
        this.ruleForm.fileList = [{ name: file.name, url: image.cdn_url }];
      }
    },
    onRemove(file) {
      let delIndex = -1;
      this.ruleForm.fileList.forEach((val, index) => {
        if (val.url === file.url) delIndex = index;
      });
      if (delIndex >= 0) {
        this.ruleForm.fileList.splice(delIndex, 1);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let { fileList, name, notice, description, allow_join } =
            this.ruleForm;
          updateStudioProfile({
            json: 1,
            head: fileList[0].url,
            name,
            notice,
            description,
            allow_join: allow_join ? 1 : 0,
          }).then(res => {
            if (res.code === 0) {
              this.$message.success('提交申请成功，请等待审核后生效');
              setTimeout(() => {
                this.$router.push({ name: 'settingsEntry' });
              }, 2000);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>
<style lang="scss" scoped>
.container {
  .content-inner-wrap {
    .el-form {
      width: 620px;
      margin: 60px auto 0;
      ::v-deep .el-form-item__label {
        color: #595959;
        font-size: 16px;
      }
      ::v-deep .el-input__inner,
      ::v-deep .el-textarea__inner {
        width: 359px;
      }
      ::v-deep .el-select .el-input__inner {
        width: 148px;
      }
    }
    .el-tips {
      text-align: center;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #bfbfbf;
      line-height: 21px;
      margin-bottom: 38px;
    }
  }
}
</style>
